import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { CANCEL_DEFINITIVE } from '../../../../shared/utils/constants';
import ModalComponent from '../../../../shared/components/Modal';
import InvoiceCancelOptions from './InvoiceCancelOptions';

const ModalOptions = (props) => {
  const { t, modal, toggle, onConfirm, dto } = props;

  const [modalSmartPay, setModalSmartPay] = useState(false);
  const [isSmartPay, setIsSmartPay] = useState(false);

  const toggleModalSmartPay = () => {
    setModalSmartPay(!modalSmartPay);
  };

  const getInvoiceWithTypeCancel = (type) => {
    return {
      ...dto,
      type: type || CANCEL_DEFINITIVE,
    };
  };

  useEffect(() => {
    const { account } = dto;
    if (account.smartpay) {
      setIsSmartPay(!isSmartPay);
    }
  }, [dto]);

  return (
    <Fragment>
      <div>
        {!modalSmartPay && (
          <ModalComponent
            toggle={toggle}
            modal={modal}
            color="warning"
            title={t('notifications.attention')}
            btn="Warning"
            message={
              isSmartPay
                ? t('notifications.invoice-linked-charge_modal')
                : t('notifications.cancel-financial_modal')
            }
            onConfirm={
              isSmartPay
                ? () => {
                    toggleModalSmartPay();
                  }
                : () => onConfirm(getInvoiceWithTypeCancel())
            }
          />
        )}
        {modalSmartPay && (
          <InvoiceCancelOptions
            isOpen={modalSmartPay}
            toggle={toggleModalSmartPay}
            onConfirm={(type) => {
              toggleModalSmartPay();
              onConfirm(getInvoiceWithTypeCancel(type));
            }}
          />
        )}
      </div>
    </Fragment>
  );
};

ModalOptions.propTypes = {
  t: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
};

export default withTranslation('common')(ModalOptions);
